import * as ko from "knockout";
import { person_cal_except } from "entitiesE";
import * as _ from "lodash";
import labels from "app/labels";

export class calendar_exception extends person_cal_except {
  isActive: KnockoutObservable<boolean>;
  translatedExceptionName: KnockoutComputed<string>;

  constructor(item: any) {
    super(item);
    this.isActive = ko.observable(false);

    this.translatedExceptionName = ko.pureComputed(() => {
      const exceptionType = this.exception_type();
      if (!exceptionType) {
        return "";
      }
      return labels.descr(`cc_P_${_.upperCase(exceptionType)}`);
    });
  }
}
